import { render, staticRenderFns } from "./TagsForm.vue?vue&type=template&id=0626daa3&"
import script from "./TagsForm.vue?vue&type=script&lang=js&"
export * from "./TagsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports